
<template>
    <div>
      <action-bar>
      </action-bar>
        <main class="content">
            <div v-if="results">
                <h1>Resultat bearbeiten</h1>
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                      <router-link class="nav-link"
                                  :to="{name: 'result-edit', params: {resultId: $route.params.resultId}}" exact>
                          Generelles
                      </router-link>
                  </li>
                </ul>
                <div class="tab-content">
                    <router-view class="tab-pane fade show active" :data="{ results, general: true }" entity="result"/>
                </div>
            </div>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';

export default {
  asyncComputed: {
    results() {
      let test = store.state.language;
      return axios
        .get("/api/" + store.state.language + "/result/list")
        .then(({ data }) => data.result);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/result/GeneralEdit.vue